<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-card header="Información del Impuesto">
          <b-form>
            <b-form-group
              label="Organismo"
              label-for="impuestoOrganismoNombre"
              :label-cols="2"
              horizontal>
              <b-form-input 
                id="impuestoOrganismoNombre"
                :value="impuestoOrganismoNombre" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Nombre"
              label-for="nombreComercial"
              :label-cols="2"
              horizontal>
              <b-form-input 
                id="nombreComercial"
                v-model.trim= "$v.nombreComercial.$model" 
                :state="nombreComercialValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="nombreComercialFeedback">
                {{ nombreComercialInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group 
              label="Presentación"
              :labelCols="2"
              horizontal>
              <b-form-radio-group
                v-model="impuestoPresentacionAnual"
                :options="opcionesPresentacion"
                name="presentacion"
                stacked>
              </b-form-radio-group>
            </b-form-group>

            <app-cuenta
              label="Cuenta"
              :nombre="cuentaNombre"
              :lista="cuentasList"
              :labelCols="labelCols"
              :nullDisabled="false"
              @updated="cuentaActualizada">
            </app-cuenta>

            <app-rubro
              label="Rubro"
              :nombre="rubroNombre"
              :lista="rubrosList"
              :labelCols="labelCols"
              :nullDisabled="false"
              :valido="rubroValido"
              :msjInvalido="rubroInvalidoMsj"
              @updated="rubroActualizado">
            </app-rubro>

            <app-subrubro
              label="Subrubro"
              :nombre="subrubroNombre"
              :lista="subrubrosList"
              :labelCols="labelCols"
              :nullDisabled="false"
              :valido="subrubroValido"
              :msjInvalido="subrubroInvalidoMsj"
              @updated="subrubroActualizado">
            </app-subrubro>  

            <b-form-group
              label-for="inactivo"
              :label-cols="2"
              horizontal>
              <b-form-checkbox 
                  id="inactivo"
                  v-model="inactivo"
                  value= true
                  unchecked-value= false>
                  Inactivo
              </b-form-checkbox>
            </b-form-group>
          </b-form>

          <b-alert
            class= "alert"
            :show="dismissCountDown"
            dismissible
            fade
            :variant="alertVariant"
            @dismissed="dismissCountDown = 0"
            @dismiss-count-down="countDownChanged">
            <p>{{ alertMsj }}</p>
          </b-alert>

          <div slot="footer" v-if="modal">
            <b-button size="sm" variant="primary" class="footer-button"
              @click.prevent="save">Grabar</b-button>
            <b-button size="sm" variant="danger" class="footer-button"
              @click.prevent="goBack">Cancelar</b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <app-a-b-m-button
      v-if= "!modal"
      @save="save"
      @cancel="goBack">
    </app-a-b-m-button>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Cuenta from '../shared/abmSelect.vue';
import Rubro from '../shared/abmSelect.vue';
import Subrubro from '../shared/abmSelect.vue';
import ABMButtons from '../shared/abmButtons.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs'
import { required, maxLength } from 'vuelidate/lib/validators';
import { createHelpers } from 'vuex-map-fields';
import moment from 'moment';
//import { getMesNumero, getDias, getMeses, getAnios } from '../../mixins/helpers';

const { mapFields } = createHelpers({
  getterType: 'proveedor/getField',
  mutationType: 'proveedor/updateField',
});

export default {
  name: 'ImpuestoABM',
  props: {
    // impuestoOrganismo: {
    //   type: Object,
    //   default: null
    // },
    modal: {
      type: Boolean,
      default: false
    }
  },
  components: {
    appCuenta: Cuenta,
    appRubro: Rubro,
    appSubrubro: Subrubro,
    appABMButton: ABMButtons,
    appMensaje: Mensaje
  },
  mixins: [
    msjModal, 
  ],
  data () {
    return {
      alertCountDown: 10, 
      dismissCountDown: 0,
      alertVariant: 'danger',
      alertMsj: '',

      labelCols: 2,
      loadingCuentas: false,

      noValidar: true,
      nombreComercialValido: null,
      nombreComercialInvalidoMsj: '',
      cuentaValida: null,
      cuentaInvalidaMsj: '',
      rubroValido: null,
      rubroInvalidoMsj: '',
      subrubroValido: null,
      subrubroInvalidoMsj: '',
      // observacionesValidas: null,
      // observacionesInvalidasMsj: '',

      opcionesPresentacion: [
        { text: 'Anual', value: true },
        { text: 'Mensual', value: false },
      ],
      cuentas: [],
      cuentasList: [],
      rubros: [],
      rubrosList: [],
      subrubros: [],
      subrubrosList: [],
    }
  },
  computed: {
    ...mapFields([
      'id',
      'impuestoOrganismoId',
      'impuestoOrganismo',
      'nombreComercial',
      'impuestoPresentacionAnual',
      'cuenta',
      'cuentaNombre',
      'rubro',
      'rubroNombre',
      'subrubro',
      'subrubroNombre',
      // 'observaciones',
      'inactivo',
    ]),
    impuestoOrganismoNombre() {
      if (this.impuestoOrganismo) {
        if (this.impuestoOrganismo.nombre) {
          return this.impuestoOrganismo.nombre.trim();
        }
      }
     
      return '';
    }

  },  
  created() {
    let impuestoOrganismoId = 0;
    let proveedorId = 0;

    // if (this.impuestoOrganismo) {
    //   id = 0;
    //   impuestoOrganismoId= this.impuestoOrganismo.id;
    // } else {
      if (this.$route.params){
        if (this.$route.params.id){
          proveedorId = this.$route.params.id;
        }
        if (this.$route.params.impuestoOrganismoId){
          impuestoOrganismoId = this.$route.params.impuestoOrganismoId;
        }
      }
    // }

    let params= {
      impuestoOrganismoId,
      proveedorId
    }

    this.showSpinner();
    this.loadingCuentas = true;
    this.$store.dispatch('proveedor/inicializar', params)
      .then(() => this.getDatosAdicionales())
      .catch(error => {
        if (!this.modal) {
          this.showErrorMsj(error)
        } else {
          this.showAlert(error, 'danger');
        }
      })
      .finally(() => {
        this.loadingCuentas = false;
        this.hideSpinner()
      });
  },  
  methods: {
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert(alertMsj, alertVariant) {
      this.alertMsj = alertMsj;
      this.alertVariant = alertVariant;
      this.alertCountDown = 15;
      this.dismissCountDown = this.alertCountDown;
    },
    getDatosAdicionales() {
      const vm = this

      this.cuentas = [];
      this.cuentasList = [];
      this.$store.dispatch('cuentas/getList')
        .then(() => {
          this.cuentas = this.$store.getters['cuentas/list']
          this.cuentasList = this.$store.getters['cuentas/selectList']
          return;
        })
        .then (() => {
          this.getRubros(false);
          return;
        })
        .then (() => {
          this.getSubrubros(false);
          return;
        })
        .catch(() => this.showErrorMsj('Se produjo un error al recuperar la información de cuentas.'));
    },
    getRubros(inicializar) {
      let rubroNombre = this.rubroNombre;
      let subrubroNombre = this.subrubroNombre;
      if (inicializar) {
        rubroNombre = null;
        subrubroNombre = null;
      }

      this.rubrosList = []
      if (this.cuentaNombre) { 
        let cuenta = this.cuentas.find(cuenta => cuenta.nombre.trim() == this.cuentaNombre.trim());
        if (cuenta) {
          cuenta.rubros.forEach(rubro => {
            this.rubrosList.push(rubro.nombre);
          });
        }
      }
      this.rubroNombre = rubroNombre;
    },
    getSubrubros(inicializar) {
      let subrubroNombre = this.subrubroNombre;
      if (inicializar) {
        subrubroNombre = null;
      }

      this.subrubrosList = []
      if (this.cuentaNombre) { 
        let cuenta = this.cuentas.find(cuenta => cuenta.nombre.trim() == this.cuentaNombre.trim());
        if (cuenta) {
          if (this.rubroNombre) {
            let rubro = cuenta.rubros.find(rubro => rubro.nombre.trim() == this.rubroNombre.trim());
            if (rubro) {
              rubro.subrubros.forEach(subrubro => {
                this.subrubrosList.push(subrubro.nombre);
              });
            }
          }
        }
      }
      this.subrubroNombre = subrubroNombre;
    },
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar) {
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == "nombreComercial" || validarTodos) {
        if (this.$v.nombreComercial.$error) {
          this.nombreComercialValido = false;
          if (!this.$v.nombreComercial.required) {
            this.nombreComercialInvalidoMsj = 'Debe ingresar el nombre del impuesto';
          } else if (!this.$v.nombreComercial.maxLength) {
            this.nombreComercialInvalidoMsj = 'El nombre sólo puede contener hasta 50 caracteres';
          }
        } else {
          this.nombreComercialValido = null;
          this.nombreComercialInvalidoMsj = '';
        }
      }

      // if (campo == 'observaciones' || validarTodos) {
      //   if (this.$v.observaciones.$error) {
      //     this.observacionesValidas = false;
      //     if (!this.$v.observaciones.maxLength) {
      //       this.observacionesInvalidasMsj = 'Las observaciones solo pueden contener hasta 5000 caracteres';
      //     }      
      //   } else {
      //     this.observacionesValidas = null;
      //     this.observacionesInvalidasMsj = '';
      //   }
      // }
    },
    save () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      this.$v.$touch()

      let save = Boolean(true);

      let cuenta;
      let rubro;
      let subrubro;

      if (this.cuentaNombre) {
        cuenta = this.cuentas.find(cuenta => cuenta.nombre.trim() == this.cuentaNombre.trim());
      }
      if (cuenta && this.rubroNombre) {
          rubro = cuenta.rubros.find(rubro => rubro.nombre.trim() == this.rubroNombre.trim());
          if (rubro && this.subrubroNombre)  {
            subrubro = rubro.subrubros.find(subrubro => subrubro.nombre.trim() == this.subrubroNombre.trim());
          }
      }

      this.$store.dispatch('proveedor/setCuenta', cuenta);
      this.$store.dispatch('proveedor/setRubro', rubro);
      this.$store.dispatch('proveedor/setSubrubro', subrubro);

      if (cuenta && !rubro) {
        if (cuenta.rubros) {
          if (cuenta.rubros.length != 0) {
            this.rubroValido = false;
            this.rubroInvalidoMsj = "Debe seleccionar un rubro";
            save = false;
          }
        }
      }
      if (rubro && !subrubro) {
        if (rubro.subrubros) {
          if (rubro.subrubros.length != 0) {
            this.subrubroValido = false;
            this.subrubroInvalidoMsj = "Debe seleccionar un subrubro";
            save = false;
          }
        }
      }

      if (save) {
        if (this.$v.$anyError) {
          this.displayErrores();
        } else {
          this.showSpinner();
          this.$store.dispatch('proveedor/save')
            .then(() => {
              if (!this.modal) {
                this.showModalMsj('Los cambios se registraron con éxito.', this.goList, this.goList, 'light')
              } else {
                this.$emit('updateImpuestos', this.nombre.toUpperCase().trim());
              }
            })
            .catch(error => {
              if (!this.modal) {
                this.showErrorMsj(error)
              } else {
                this.showAlert(error, 'danger');
              }
            })
            .finally(() => this.hideSpinner());
        }
      }
    },
    goBack() {
      if (!this.modal) {
        this.$router.push({ name: 'Impuestos', 
                            params: { impuestoOrganismoId: this.impuestoOrganismoId }});
      } else {
        this.$emit('closeImpuesto');
      }
    },
    goList() {
      this.$router.push({ name: 'Impuestos', 
                          params: { impuestoOrganismoId: this.impuestoOrganismoId }});
    },
    cuentaActualizada(cuentaNombre) {
      if (!this.loadingCuentas) {
        this.cuentaNombre = cuentaNombre;
        this.cuentaValida = null;
        this.cuentaInvalidaMsj = '';

        this.getRubros(true);
      }
    },
    rubroActualizado(rubroNombre) {
      if (!this.loadingCuentas) {
        this.rubroNombre = rubroNombre;
        this.rubroValido = null;
        this.rubroInvalidoMsj = '';
        this.getSubrubros(true);
      }
    },
    subrubroActualizado(subrubroNombre) {
      if (!this.loadingCuentas) {
        this.subrubroNombre = subrubroNombre;
        this.subrubroValido = null;
        this.subrubroInvalidoMsj = '';
      }
    },

  },
  validations: {
    nombreComercial: {
      required,
      maxLength: maxLength(50)
    },
    // observaciones: {
    //   maxLength: maxLength(5000)
    // },
  },  
}
</script>

<style>
</style>
